import React, { useEffect, useState } from 'react';

const weekLetters = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
const fullDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const AWeekPicker = ({
  selectedDays = [],
  onChange,
  disabled = false,
  multiSelect = false
}) => {

  const [activeDays, setActiveDays] = useState([]);

  useEffect(() => {
    const normalized = Array.isArray(selectedDays)
      ? selectedDays.map(day => (day?.value??day).toLowerCase())
      : [selectedDays.toLowerCase()];
    setActiveDays(normalized);
  }, [selectedDays]);

  const handleToggle = (day) => {
    if (disabled) return;

    let updated;

    if (multiSelect) {
      if (activeDays.includes(day)) {
        updated = activeDays.filter(d => d !== day);
      } else {
        updated = [...activeDays, day];
      }
    } else {
      updated = [day];
    }

    setActiveDays(updated);
    onChange && onChange(multiSelect ? updated : updated[0]);
  };

  const containerStyle = {
    display: 'flex',
    //border: '1px solid #ccc',
    //borderRadius: '8px',
    overflow: 'hidden',
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    maxWidth:'247px',
    height:'36px'
  };

  const buttonBaseStyle = {
    padding: '8px 11px',
    fontWeight: 600,
    fontSize: '14px',
    color: '#aaa',
    backgroundColor: 'white',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    transition: '0.2s ease',
  };

  const getButtonStyle = (index, isActive) => {
    const style = { ...buttonBaseStyle };

    if (index === 0) style.borderRadius = '8px 0 0 8px';
    if (index === 6) style.borderRadius = '0 8px 8px 0';

    if (isActive) {
      style.color = '#000';
      style.border = '1px solid #000';
    }
      else{
          style.border='1px solid #ccc'
      }

    return style;
  };

  return (
    <div style={containerStyle}>
      {fullDays.map((day, idx) => {
        const isActive = activeDays.includes(day);
        return (
            <div className='d-flex justify-content-center align-items-center' style={getButtonStyle(idx, isActive)}
            onClick={() => handleToggle(day)}
            >

            {weekLetters[idx]}

          </div>
        );
      })}
    </div>
  );
};





export default AWeekPicker;

